/* eslint-disable @typescript-eslint/no-explicit-any */
import { ComponentType, createElement, lazy, useState } from 'react';

export type PreloadableComponent<T extends ComponentType<any>> = T & {
  preload: () => Promise<T>;
};

export function lazyWithPreload<T extends ComponentType<any>>(
  factory: () => Promise<{ default: T }>
): PreloadableComponent<T> {
  const ReactLazyComponent = lazy(factory);
  let PreloadedComponent: T | undefined;
  let factoryPromise: Promise<T> | undefined;

  function LazyWithPreloadComponent(props: any) {
    const [ComponentToRender] = useState(() => PreloadedComponent ?? ReactLazyComponent);
    return createElement(ComponentToRender as ComponentType<any>, props);
  }

  const LazyWithPreload = LazyWithPreloadComponent as unknown as PreloadableComponent<T>;

  LazyWithPreload.preload = () => {
    if (!factoryPromise) {
      factoryPromise = factory().then((module) => {
        PreloadedComponent = module.default;
        return PreloadedComponent;
      });
    }

    return factoryPromise;
  };

  return LazyWithPreload;
}
